import React from "react";

export const TagRecommended = ({ text }) => <div className="tag recommended">{text}</div>;
